<ul role="menu">

  @if (displayMenu && topMenu) {
    @for (section of topMenu.sections; track section; let i = $index) {
      <li #menubutton id="section-{{i}}" class="navbar-item top">
        @if (!section.groups) {
          <a [href]="onePortalDashboard" class="navbar-link" role="menuitem" aria-expanded="false">
            <span class="header-icon-large {{section.icon}}"></span>
            <span class="menu-label">{{section.title}}</span>
          </a>
        }
        @if (section.groups) {
          <div class="btn-group" dropdown >
            <button dropdownToggle type="button" class="btn btn-light btn-sm preferences-button navbar-link"
              [attr.aria-controls]="'button-group-' + i">
              @if (!section.usephoto) {
                <span class="header-icon-large {{section.icon}}"></span>
              }
              @if (section.usephoto) {
                <img class="avatar rounded-circle" alt="View account"
                  [src]="avatar| domSanitizerPipe: 'src'" />
              }
              <div>
                <span class="menu-label">{{section.title}} <span
                class="header-icon-small icon-gecko-scroll-down"></span>
              </span>
            </div>
          </button>
          <ul #submenus id="submenu-{{i}}" *dropdownMenu class="dropdown-menu dropdown-menu-dynamic"
            [ngClass]="menuCssClass" role="menu" aria-labelledby="button-studies">
            <div [ngStyle]="{'min-width': section.groups.length*250+ 'px', 'overflow': 'hidden'}"
              style="min-width: 900px;" class="row studies-row">
              @for (group of section.groups; track group) {
                <div class="col-12"
                  [ngClass]="(section.groups.length==2)? 'col-lg-6': (section.groups.length==3)? 'col-lg-4' : 'col-lg-3'">
                  <li class="column"><span
                    [ngStyle]="{'border-bottom': !group.items? 'none': '1px solid #5b6770'}"
                    [ngClass]="{'menu-header': group.title}" data-toggle="tooltip"
                  data-placement="bottom">{{group.title}}</span>
                  @if (group.text) {
                    <div [innerHTML]="group.text"></div>
                  }
                  @if (group.items) {
                    <ul>
                      @for (item of group.items; track item) {
                        <li class="navbar-item subitem" role="none">
                          @if (!item.isConnectUsLink) {
                            <a role="menuitem"
                            href="{{item.link}}">{{item.title}}</a>
                          }
                          @if (item.isConnectUsLink) {
                            <a role="menuitem"
                            [routerLink]="[item.link]">{{item.title}}</a>
                          }
                        </li>
                      }
                    </ul>
                  }
                </li>
              </div>
            }
          </div>
        </ul>
      </div>
    }
  </li>
}
}
</ul>